import { IntlShape } from "react-intl";
import { ModuleHierachy } from "../../common/module/types";
import { INCENTIVE_TITLE, INCENTIVE_BASE_PATH, INCENTIVE_NAMESPACE, AdminIncentivePermissionType } from "./constants";
import IncentiveRoutes from "./pages/IncentiveRoutes";
import { isPermitted } from 'src/app/common/utils';

export const incentiveModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(INCENTIVE_TITLE),
    path: INCENTIVE_BASE_PATH,
    icon: "/media/svg/icons/Media/Equalizer.svg",
    namespace: INCENTIVE_NAMESPACE,
    component: IncentiveRoutes,
    enableRead: isPermitted([
      AdminIncentivePermissionType.INCENTIVE_READ,
      AdminIncentivePermissionType.INCENTIVE_CREATE,
      AdminIncentivePermissionType.INCENTIVE_UPDATE
    ], permissions),
    enableCreate: isPermitted([
      AdminIncentivePermissionType.INCENTIVE_CREATE
    ], permissions),
    enableUpdate: isPermitted([
      AdminIncentivePermissionType.INCENTIVE_UPDATE
    ], permissions)
  }
}